var map = {
	"./Featured-Freebie-Background-Image.png": "dXap",
	"./Featured-Freebie-Profile-Image.png": "Rr0a",
	"./SplashPage.jpg": "ew51",
	"./app-header-logo.png": "Wxnf",
	"./app-slide-show1.png": "wHOT",
	"./app-slide-show2.png": "/rC7",
	"./app-slide-show3.png": "xiYx",
	"./app-slide-show4.png": "FXLt",
	"./app-slide-show5.png": "elHN",
	"./coupon.svg": "3INK",
	"./get-perked-logo-250.png": "algo",
	"./get-perked-logo-org-prpl-250.png": "kRSJ",
	"./get-perked-logo-reverse-250.png": "VKUl",
	"./homecenter.png": "ewND",
	"./icon.png": "bGtA",
	"./location.svg": "XplH",
	"./profile.svg": "3dw/",
	"./star.svg": "1Upy"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "TAJN";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-orlkis-wgm/images ^\.\/.*$
// module id = TAJN
// module chunks = 44